// extracted by mini-css-extract-plugin
export default {"twoImageSection":"TwoImageSection_twoImageSection__0FlFW","media":"TwoImageSection_media__bI7Wj","VideoWrapper":"TwoImageSection_VideoWrapper__oqn0-"};